import React from 'react';
import {css} from 'emotion';
import Styled from 'react-emotion';
import AniLink from "gatsby-plugin-transition-link/AniLink";
import { Link } from 'gatsby';
import Row from './Row'
import DownloadAppButton from './appComponents/DownloadAppButton';
import DownloadAppButtonMobile from './appComponents/DownloadAppButtonMobile';


/* global tw */

const styles = {
    headerLogo: css`
        height: 32px;
        width: auto;
        transition: transform 0.25s ease;
        @media (min-width: 992px){
            height: 40px;
        }
        &:hover { transform: scale(1.04); }
    `,
    menuList: css`
        ${tw`list-reset block`};

    `,
    menuListItem: css`
        ${tw`hidden lg:inline-flex items-center lg:mx-4 relative `};

    `,
}

const NavBar = (props) => (
    <div className={css`
        ${tw`w-screen overflow-hidden absolute pin-t py-4 z-100`};
        background: linear-gradient(180deg, rgba(10,10,15,0.7) 0%, rgba(10,10,15,0) 100%);
    `}>
    <div className={css`${tw`mx-auto -mt-2 max-w-row w-full flex items-center justify-between flex-wrap px-4 lg:px-1`}`}>

    <div className={css`${tw`flex items-center`}`}>
        <img className={styles.headerLogo}
             src={require('../assets/img/zyppys-logo.png')}
             alt="Zyppys Logo"/>
        <div className={css`
            ${tw`text-white text-3xl lg:text-4xl pl-3`};
            font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
            font-weight: 800;
            letter-spacing: -0.04em;
            background: linear-gradient(135deg, #FFFFFF 0%, #CB53D1 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        `}>zyppys</div>
    </div>


        <div className={css`${tw`flex items-center`}`}>
            <Link to="/concierge/" className={css`
                ${tw`hidden lg:inline-flex items-center text-white no-underline mr-3`};
                font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
                font-weight: 600;
                font-size: 0.9375rem;
                letter-spacing: -0.005em;
                padding: 0.5rem 0.875rem;
                border-radius: 6px;
                color: #F5F5F7;
                transition: all 0.2s ease;
                &::before {
                    content: '';
                    display: inline-block;
                    width: 6px;
                    height: 6px;
                    border-radius: 9999px;
                    background: #C9A2FF;
                    margin-right: 0.5rem;
                    box-shadow: 0 0 10px rgba(201,162,255,0.55);
                }
                &:hover {
                    color: #C9A2FF;
                    background: rgba(201, 162, 255, 0.08);
                }
            `}>
                Concierge
            </Link>
            <Link to="/partners/" className={css`
                ${tw`hidden lg:inline-flex items-center text-white no-underline mr-3`};
                font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
                font-weight: 500;
                font-size: 0.9375rem;
                letter-spacing: -0.005em;
                padding: 0.5rem 0.875rem;
                border-radius: 6px;
                color: #F5F5F7;
                transition: all 0.2s ease;
                &:hover {
                    color: #F5F5F7;
                    background: rgba(255, 255, 255, 0.05);
                }
            `}>
                Partners
            </Link>
            <a href="tel:+918688901902" className={css`
                ${tw`hidden lg:inline-flex items-center text-white no-underline`};
                font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
                font-weight: 500;
                font-size: 0.9375rem;
                letter-spacing: -0.005em;
                padding: 0.5rem 1rem;
                border-radius: 6px;
                background: rgba(255, 255, 255, 0.04);
                border: 1px solid rgba(255, 255, 255, 0.10);
                transition: all 0.2s ease;
                &:hover {
                    background: rgba(255, 255, 255, 0.07);
                    border-color: rgba(255, 255, 255, 0.18);
                }
                &::before {
                    content: '';
                    display: inline-block;
                    width: 6px;
                    height: 6px;
                    border-radius: 9999px;
                    background: #2DD4BF;
                    margin-right: 0.5rem;
                    box-shadow: 0 0 0 3px rgba(45, 212, 191, 0.18);
                }
            `}>
                Support : +91 8688 901 902
            </a>
            <a href="tel:+918688901902" className={css`
                ${tw`lg:hidden text-white no-underline text-sm`};
                font-weight: 500;
                opacity: 0.9;
            `}>
                +91 8688 901 902
            </a>

            <div className={css`${tw`ml-3 lg:ml-5`}`}>
                <DownloadAppButton light hideOnMobile/>
                <DownloadAppButtonMobile hide/>
            </div>
        </div>
    </div>
</div>



);


export default NavBar;
